import http from "../http";
import ApiConstants from "../constants/ApiConstants";

class DashboardService {

    static getClaimsTrendByInterval(interval) {
        const url = `${ApiConstants.URL.BASE + ApiConstants.URL.EXPENSE.CLAIMS_BY_TREND}\?trend_view=${interval}`
        return http.get(url).catch((err:any) => {
            console.error('Error while claims trend ', err);
            return Promise.reject(err);
        })
    }

    static getDashboardSetting() {
        const url = `${ApiConstants.URL.SETTINGS.USER}?appName=PEOPLE`
        return http.get(url).catch((err:any) => {
            console.error('Error getting dashboard settings ', err);
            return Promise.reject(err);
        })
    }

    static updateDashboardSetting(data) {
        const url = `${ApiConstants.URL.SETTINGS.USER}`
        return http.patch(url, data).catch((err:any) => {
            console.error('Error while updating dashboard settings ', err);
            return Promise.reject(err);
        })
    }
    static getPreference() {
        return http.get(ApiConstants.URL.SETTINGS.USER);
    }
    static setPreference(payload) {
        return http.patch(ApiConstants.URL.SETTINGS.USER, payload);
    }
}

export default DashboardService